import Head from 'expo-router/head';

import LoyaltyOffersDetails from '@fhs-legacy/frontend/src/pages/loyalty/loyalty-offers/loyalty-offers';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function RewardsOfferDetailsPage() {
  return (
    <>
      <Head>
        <title>Offer Details - Firehouse Subs</title>
      </Head>
      <LoyaltyOffersDetails />
    </>
  );
}
